import { useState } from 'react';

export default function StoresTab() {
  const [showAddModal, setShowAddModal] = useState(false);
  const [viewMode, setViewMode] = useState<'grid' | 'list'>('grid');

  const stores = [
    { id: 1, name: '東京本店', address: '東京都千代田区丸の内1-1-1', phone: '03-1234-5678', models: 45, size: '2.3 GB', status: 'active', image: 'https://readdy.ai/api/search-image?query=Modern%20luxury%20retail%20store%20interior%20with%20elegant%20lighting%20and%20display%20cases%20in%20Tokyo%2C%20professional%20commercial%20photography%2C%20clean%20minimalist%20design%2C%20bright%20and%20spacious&width=400&height=300&seq=store1&orientation=landscape' },
    { id: 2, name: '大阪支店', address: '大阪府大阪市北区梅田2-2-2', phone: '06-2345-6789', models: 38, size: '1.9 GB', status: 'active', image: 'https://readdy.ai/api/search-image?query=Contemporary%20retail%20store%20interior%20in%20Osaka%20with%20modern%20fixtures%20and%20warm%20lighting%2C%20professional%20commercial%20photography%2C%20sophisticated%20design%2C%20welcoming%20atmosphere&width=400&height=300&seq=store2&orientation=landscape' },
    { id: 3, name: '名古屋店', address: '愛知県名古屋市中区栄3-3-3', phone: '052-3456-7890', models: 32, size: '1.6 GB', status: 'active', image: 'https://readdy.ai/api/search-image?query=Stylish%20retail%20store%20interior%20in%20Nagoya%20with%20contemporary%20design%20elements%20and%20product%20displays%2C%20professional%20commercial%20photography%2C%20modern%20aesthetic%2C%20bright%20environment&width=400&height=300&seq=store3&orientation=landscape' },
    { id: 4, name: '福岡店', address: '福岡県福岡市中央区天神4-4-4', phone: '092-4567-8901', models: 28, size: '1.4 GB', status: 'active', image: 'https://readdy.ai/api/search-image?query=Modern%20retail%20store%20interior%20in%20Fukuoka%20with%20sleek%20design%20and%20organized%20product%20presentation%2C%20professional%20commercial%20photography%2C%20clean%20lines%2C%20inviting%20space&width=400&height=300&seq=store4&orientation=landscape' },
    { id: 5, name: '札幌店', address: '北海道札幌市中央区大通5-5-5', phone: '011-5678-9012', models: 25, size: '1.2 GB', status: 'maintenance', image: 'https://readdy.ai/api/search-image?query=Contemporary%20retail%20store%20interior%20in%20Sapporo%20with%20modern%20design%20and%20efficient%20layout%2C%20professional%20commercial%20photography%2C%20functional%20elegance%2C%20well-lit%20space&width=400&height=300&seq=store5&orientation=landscape' },
    { id: 6, name: '横浜店', address: '神奈川県横浜市西区みなとみらい6-6-6', phone: '045-6789-0123', models: 42, size: '2.1 GB', status: 'active', image: 'https://readdy.ai/api/search-image?query=Upscale%20retail%20store%20interior%20in%20Yokohama%20with%20premium%20finishes%20and%20sophisticated%20displays%2C%20professional%20commercial%20photography%2C%20luxurious%20ambiance%2C%20spacious%20layout&width=400&height=300&seq=store6&orientation=landscape' },
  ];

  return (
    <div className="p-8">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="text-2xl font-bold text-gray-900 mb-2">店舗データ管理</h2>
          <p className="text-gray-600">店舗情報と関連する3Dデータの管理</p>
        </div>
        <div className="flex items-center gap-3">
          <div className="flex items-center gap-1 bg-white border border-gray-200 rounded-lg p-1">
            <button
              onClick={() => setViewMode('grid')}
              className={`px-3 py-2 rounded-md transition-colors cursor-pointer ${
                viewMode === 'grid' ? 'bg-teal-500 text-white' : 'text-gray-600 hover:bg-gray-100'
              }`}
            >
              <i className="ri-grid-line"></i>
            </button>
            <button
              onClick={() => setViewMode('list')}
              className={`px-3 py-2 rounded-md transition-colors cursor-pointer ${
                viewMode === 'list' ? 'bg-teal-500 text-white' : 'text-gray-600 hover:bg-gray-100'
              }`}
            >
              <i className="ri-list-check"></i>
            </button>
          </div>
          <button
            onClick={() => setShowAddModal(true)}
            className="px-6 py-3 bg-teal-500 text-white rounded-lg font-medium hover:bg-teal-600 transition-colors flex items-center gap-2 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-add-line text-lg"></i>
            新規店舗
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        <div className="bg-white rounded-xl p-6 border border-gray-200/80">
          <div className="flex items-center justify-between mb-4">
            <div className="w-12 h-12 bg-teal-500 rounded-lg flex items-center justify-center">
              <i className="ri-store-2-fill text-2xl text-white"></i>
            </div>
          </div>
          <h3 className="text-3xl font-bold text-gray-900 mb-1">{stores.length}</h3>
          <p className="text-sm text-gray-600">総店舗数</p>
        </div>

        <div className="bg-white rounded-xl p-6 border border-gray-200/80">
          <div className="flex items-center justify-between mb-4">
            <div className="w-12 h-12 bg-green-500 rounded-lg flex items-center justify-center">
              <i className="ri-checkbox-circle-fill text-2xl text-white"></i>
            </div>
          </div>
          <h3 className="text-3xl font-bold text-gray-900 mb-1">{stores.filter(s => s.status === 'active').length}</h3>
          <p className="text-sm text-gray-600">稼働中</p>
        </div>

        <div className="bg-white rounded-xl p-6 border border-gray-200/80">
          <div className="flex items-center justify-between mb-4">
            <div className="w-12 h-12 bg-purple-500 rounded-lg flex items-center justify-center">
              <i className="ri-cube-fill text-2xl text-white"></i>
            </div>
          </div>
          <h3 className="text-3xl font-bold text-gray-900 mb-1">{stores.reduce((sum, s) => sum + s.models, 0)}</h3>
          <p className="text-sm text-gray-600">総3Dモデル数</p>
        </div>

        <div className="bg-white rounded-xl p-6 border border-gray-200/80">
          <div className="flex items-center justify-between mb-4">
            <div className="w-12 h-12 bg-orange-500 rounded-lg flex items-center justify-center">
              <i className="ri-database-2-fill text-2xl text-white"></i>
            </div>
          </div>
          <h3 className="text-3xl font-bold text-gray-900 mb-1">10.5 GB</h3>
          <p className="text-sm text-gray-600">総データサイズ</p>
        </div>
      </div>

      {viewMode === 'grid' ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {stores.map((store) => (
            <div key={store.id} className="bg-white rounded-xl border border-gray-200/80 overflow-hidden hover:shadow-lg transition-shadow">
              <div className="relative h-48 bg-gray-200">
                <img 
                  src={store.image} 
                  alt={store.name}
                  className="w-full h-full object-cover object-top"
                />
                <span className={`absolute top-3 right-3 px-3 py-1 rounded-full text-xs font-medium ${
                  store.status === 'active' 
                    ? 'bg-green-500 text-white' 
                    : 'bg-yellow-500 text-white'
                }`}>
                  {store.status === 'active' ? '稼働中' : 'メンテナンス'}
                </span>
              </div>
              <div className="p-6">
                <h3 className="text-lg font-bold text-gray-900 mb-3">{store.name}</h3>
                <div className="space-y-2 mb-4">
                  <div className="flex items-start gap-2 text-sm text-gray-600">
                    <i className="ri-map-pin-line mt-0.5 flex-shrink-0"></i>
                    <span>{store.address}</span>
                  </div>
                  <div className="flex items-center gap-2 text-sm text-gray-600">
                    <i className="ri-phone-line"></i>
                    <span>{store.phone}</span>
                  </div>
                </div>
                <div className="flex items-center justify-between pt-4 border-t border-gray-200/80">
                  <div className="flex items-center gap-4 text-sm text-gray-600">
                    <span className="flex items-center gap-1">
                      <i className="ri-cube-line"></i>
                      {store.models}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-database-2-line"></i>
                      {store.size}
                    </span>
                  </div>
                  <button className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-gray-100 transition-colors cursor-pointer">
                    <i className="ri-more-2-fill text-gray-600"></i>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="bg-white rounded-xl border border-gray-200/80">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-50/80 border-b border-gray-200/80">
                <tr>
                  <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">店舗名</th>
                  <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">住所</th>
                  <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">電話番号</th>
                  <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">3Dモデル</th>
                  <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">データサイズ</th>
                  <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">ステータス</th>
                  <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">操作</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200/80">
                {stores.map((store) => (
                  <tr key={store.id} className="hover:bg-gray-50/50 transition-colors">
                    <td className="px-6 py-4">
                      <div className="flex items-center gap-3">
                        <div className="w-10 h-10 bg-gradient-to-br from-teal-400 to-teal-600 rounded-lg flex items-center justify-center">
                          <i className="ri-store-2-fill text-white text-lg"></i>
                        </div>
                        <span className="font-medium text-gray-900">{store.name}</span>
                      </div>
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-600">{store.address}</td>
                    <td className="px-6 py-4 text-sm text-gray-600">{store.phone}</td>
                    <td className="px-6 py-4 text-sm text-gray-600">{store.models}個</td>
                    <td className="px-6 py-4 text-sm text-gray-600">{store.size}</td>
                    <td className="px-6 py-4">
                      {store.status === 'active' ? (
                        <span className="px-3 py-1 bg-green-100 text-green-700 rounded-full text-xs font-medium">
                          稼働中
                        </span>
                      ) : (
                        <span className="px-3 py-1 bg-yellow-100 text-yellow-700 rounded-full text-xs font-medium">
                          メンテナンス
                        </span>
                      )}
                    </td>
                    <td className="px-6 py-4">
                      <div className="flex items-center gap-2">
                        <button className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-gray-100 transition-colors cursor-pointer">
                          <i className="ri-eye-line text-gray-600"></i>
                        </button>
                        <button className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-gray-100 transition-colors cursor-pointer">
                          <i className="ri-edit-line text-gray-600"></i>
                        </button>
                        <button className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-red-50 transition-colors cursor-pointer">
                          <i className="ri-delete-bin-line text-red-600"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {showAddModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl max-w-2xl w-full p-8">
            <div className="flex items-center justify-between mb-6">
              <h3 className="text-xl font-bold text-gray-900">新規店舗登録</h3>
              <button
                onClick={() => setShowAddModal(false)}
                className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-gray-100 transition-colors cursor-pointer"
              >
                <i className="ri-close-line text-xl text-gray-600"></i>
              </button>
            </div>

            <div className="space-y-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">店舗名</label>
                <input
                  type="text"
                  placeholder="例: 東京本店"
                  className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">住所</label>
                <input
                  type="text"
                  placeholder="例: 東京都千代田区丸の内1-1-1"
                  className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">電話番号</label>
                <input
                  type="tel"
                  placeholder="例: 03-1234-5678"
                  className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">店舗画像</label>
                <div className="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center hover:border-teal-500 transition-colors cursor-pointer">
                  <i className="ri-image-add-line text-4xl text-gray-400 mb-3"></i>
                  <p className="text-sm text-gray-600 mb-1">クリックまたはドラッグ&ドロップで画像をアップロード</p>
                  <p className="text-xs text-gray-500">対応形式: JPG, PNG (最大10MB)</p>
                </div>
              </div>

              <div className="flex items-center gap-3 pt-4">
                <button
                  onClick={() => setShowAddModal(false)}
                  className="flex-1 px-6 py-3 border border-gray-200 text-gray-700 rounded-lg font-medium hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap"
                >
                  キャンセル
                </button>
                <button className="flex-1 px-6 py-3 bg-teal-500 text-white rounded-lg font-medium hover:bg-teal-600 transition-colors cursor-pointer whitespace-nowrap">
                  登録
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
